import { render, staticRenderFns } from "./EditArticleCategorySidebar.vue?vue&type=template&id=7f589ef1&scoped=true"
import script from "./EditArticleCategorySidebar.vue?vue&type=script&lang=js"
export * from "./EditArticleCategorySidebar.vue?vue&type=script&lang=js"
import style0 from "./EditArticleCategorySidebar.vue?vue&type=style&index=0&id=7f589ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f589ef1",
  null
  
)

export default component.exports